import React, { FunctionComponent } from 'react';

import { CardList } from 'components';
import { Extra } from 'scenes/common/types';

import { OptionalExtraCard } from './OptionalExtraCard';

const ADDED = 'Added to the premium';
const INCLUDED = 'Included in the premium';

const isSelected = (
  selectedExtras: string[],
  optionalExtra: string,
  includedExtras?: string[]
): boolean =>
  includedExtras?.some((option) => option === optionalExtra) ||
  selectedExtras.some((option) => option === optionalExtra);

const getAdditionalText = (
  selectedExtras: string[],
  option: Extra,
  includedExtras?: string[]
): string => {
  if (includedExtras?.some((includedExtra) => includedExtra === option.code)) {
    return INCLUDED;
  }
  if (selectedExtras.some((selectedExtra) => selectedExtra === option.code)) {
    return ADDED;
  }

  return option.additionalText ?? '';
};

const OptionalExtrasList: FunctionComponent<{
  includedExtras?: string[];
  selectedExtras: string[];
  availableExtras: Extra[];
  onClick: (optionalExtra: string) => void;
  numberOfOptions: number;
}> = ({
  availableExtras,
  includedExtras,
  selectedExtras,
  onClick,
  numberOfOptions,
}) => (
  <CardList>
    {availableExtras.map((option, index) => (
      <OptionalExtraCard
        key={option.code}
        image={option.image}
        label={option.label}
        additionalText={getAdditionalText(
          selectedExtras,
          option,
          includedExtras
        )}
        selected={isSelected(selectedExtras, option.code, includedExtras)}
        onClick={() => onClick(option.code)}
        screenReaderText={`Option ${index + 1} of ${numberOfOptions}`}
      />
    ))}
  </CardList>
);

export default OptionalExtrasList;
